import React, { useContext, useEffect, useMemo } from "react";
import UserContext from "../../../contexts/UserContext";
import OrderEntry from "../OrderEntry/OrderEntry";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import { useLocation, useMatch, useNavigate, useSearchParams } from "react-router-dom";
import { hasEditAccess } from "@services/ScreenOptionsService";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";
import ViewAccessService from "@services/ViewAccessService";

type Props = {};

export const OrderEntryWrapper = (props: Props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const navigate = useNavigate();
    const location = useLocation();
    const match = useMatch("/:entityType/:order_guid/entry");

    const hasEditMode = useMemo(() => {
        const editMode = hasEditAccess(ScreenOptionsEnum.ORDER_ENTRY, userModel, supplierModel, ViewAccessService.OrderEntry);
        return editMode;
    }, [userModel, supplierModel]);

    if (!userModel || !supplierModel) {
        return null;
    }

    return (
        <OrderEntry
            key={location.pathname}
            isOnline={uiContext.forceOnline || navigator.onLine}
            userModel={userModel}
            supplierModel={supplierModel}
            vendorModel={vendorModel}
            socket={socket}
            notifyFn={uiContext.notifyFn}
            toggleSidebar={uiContext.toggleSidebar}
            setSidebarComponent={uiContext.setSidebarComponent}
            setRightSideComponent={uiContext.setRightSideComponent}
            toggleRightSide={uiContext.toggleRightSide}
            setSubHeaderComponent={uiContext.setSubHeaderComponent}
            setRightSideHeaderComponent={uiContext.setRightSideHeaderComponent}
            setActivityIndicator={uiContext.setActivityIndicator}
            toggleMenu={uiContext.toggleMenu}
            history={navigate}
            location={location}
            match={match}
            showHiddenFeatures={uiContext.showHiddenFeatures}
            hasEditMode={hasEditMode}
            uiContext={uiContext}
        />
    );
};
